import { render, staticRenderFns } from "./ManualReview.vue?vue&type=template&id=687aaf58&scoped=true&"
import script from "./ManualReview.vue?vue&type=script&lang=js&"
export * from "./ManualReview.vue?vue&type=script&lang=js&"
import style0 from "./ManualReview.vue?vue&type=style&index=0&id=687aaf58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687aaf58",
  null
  
)

export default component.exports